"use strict";

var getProductCatalogInformationFn = require('./getProductCatalogInformation');
/**
 * @namespace ShineCatalog
 */


var ShineCatalog = function ShineCatalog() {
  var _instance;

  function init() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = opts;

    function updateOptions(newOpts) {
      options = newOpts;
    }
    /**
         *
         * @param {Product} product
         * @returns {CatalogEntry}
         */


    function getProductCatalogInformation(product) {
      return getProductCatalogInformationFn(product, options);
    }

    return {
      options: options,
      updateOptions: updateOptions,
      product: getProductCatalogInformation,
      // alias
      get: getProductCatalogInformation,
      // alias
      getProductCatalogInformation: getProductCatalogInformation
    };
  }

  return {
    /**
         * initialize
         * @param {*} opts
         * @instance
         * @example
         * import { ShineCatalog } from 'shine-products-v2';
         * ShineCatalog.initialize(opts);
         */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
         * SINGLETON INSTANCE
         * @instance
         * @example
         * import { ShineCatalog } from 'shine-products-v2';
         * ShineCatalog.instance()
         */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();

module.exports = ShineCatalog;